import { takeLatest, call, put } from "redux-saga/effects";
import {
  addCartSuccess,
  fetchDataBegin,
  fetchDataError,
  getCartSuccess,
  removeCartSuccess,
} from "./slice";
import { apiGet, apiPost } from "../../api/callApi";
import { addCart, getCart, removeCart } from "./actions";
import { showAlert } from "utils/helper";

function* addCartData(action) {
  yield put(fetchDataBegin());
  try {
    const { id, files } = action.payload;
    const response = yield call(apiPost, `/v1/cart/addtocart`, {
      projectId: id,
      files: files,
    });
    yield put(addCartSuccess({ newData: response.data }));
    showAlert({ title: "Success", text: response?.message, icon: "success" });
  } catch (error) {
    yield put(fetchDataError());
    showAlert({
      title: "Error",
      text: error?.response?.data?.message,
      icon: "error",
    });
    console.error("Get cart failed", error);
  }
}
function* getCartData(action) {
  yield put(fetchDataBegin());
  try {
    const { payload } = action;
    if (payload && payload.id) {
      const { id } = payload;
      const response = yield call(apiGet, `/v1/cart/${id}`);
      yield put(getCartSuccess({ newData: response }));
    } else {
      yield put(fetchDataError());
    }
  } catch (error) {
    yield put(fetchDataError());
    console.error("Get cart failed", error);
  }
}

function* removeCartData(action) {
  try {
    yield put(fetchDataBegin());
    const { id, files, clear, deleteOlder } = action.payload;

    const fileIds =
      files && Array.isArray(files)
        ? files.map((f) => (typeof f === "object" ? f.id : f))
        : files;

    const willDelete = yield call(showAlert, {
      title: "Are you sure?",
      text: clear
        ? "Are you sure you want to clear the cart?"
        : deleteOlder
          ? "Are you sure you want to remove older files?"
          : `Are you sure you want to remove ${fileIds.length} file${
              fileIds.length > 1 ? "s" : ""
            }?`,

      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          text: "Cancel",
          value: false,
          visible: true,
          closeModal: true,
          style: {
            backgroundColor: "#f0f0f0 !important",
            color: "#333",
            padding: "8px 16px",
            borderRadius: "4px",
            fontWeight: "bold",
          },
        },
        confirm: {
          text: clear ? "Clear" : "Remove",
          value: true,
          visible: true,
          closeModal: true,
          style: {
            backgroundColor: "#e74c3c!important",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "4px",
            fontWeight: "bold",
          },
        },
      },
    });

    if (willDelete) {
      // Proceed with deletion if user confirms
      const response = yield call(apiPost, `/v1/cart/remove/`, {
        projectId: id,
        files: fileIds,
        clear: clear,
        deleteOlder: deleteOlder,
      });
      yield put(removeCartSuccess({ files: fileIds, clear, deleteOlder }));

      // Refetch cart data from backend to ensure consistency
      const cartResponse = yield call(apiGet, `/v1/cart/${id}`);
      yield put(getCartSuccess({ newData: cartResponse }));

      showAlert({ title: "Success", text: response?.message, icon: "success" });
      // Show success message
    } else {
      // Optional: Handle cancelation logic (e.g., log or notify user)
      console.log("User canceled the deletion.");
    }
  } catch (error) {
    yield put(fetchDataError());
    console.error("Remove cart failed", error);

    // Show error message
    yield call(
      showAlert,
      "Error",
      "Failed to delete the file. Please try again.",
      "error",
    );
  }
}

export function* watchCart() {
  yield takeLatest(addCart.type, addCartData);
  yield takeLatest(getCart.type, getCartData);
  yield takeLatest(removeCart.type, removeCartData);
}
